import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useInboxStore = create(
  persist(
    (set, get) => ({
      chatOpen: false,
      unreadCount: 0,
      lastSeenMap: {}, // { [convId]: ISO timestamp }

      setChatOpen: (open) => set({ chatOpen: open }),

      // Call after fetching conversations — recalculates unread badge
      syncUnread: (conversations, userId) => {
        const { lastSeenMap } = get();
        let count = 0;
        for (const conv of conversations) {
          const lastMsg = conv.messages?.[0];
          if (!lastMsg || lastMsg.senderId === userId) continue;
          const seen = lastSeenMap[conv.id];
          if (!seen || new Date(lastMsg.createdAt) > new Date(seen)) count++;
        }
        set({ unreadCount: count });
      },

      markRead: (convId) => {
        set(s => ({
          lastSeenMap: { ...s.lastSeenMap, [convId]: new Date().toISOString() },
          unreadCount: Math.max(0, s.unreadCount - 1),
        }));
      },

      incrementUnread: () => set(s => ({ unreadCount: s.unreadCount + 1 })),
    }),
    {
      name: 'findr-inbox',
      partialize: (s) => ({ lastSeenMap: s.lastSeenMap }),
    }
  )
);

export default useInboxStore;
